export const routes = {
    SIGNUP: 'signup',
    LOGIN: 'login',
    PRODUCTS: 'products',
    FAQ: 'frequently-asked',
    BLOG: 'blog',
    NEWSLETTERS: 'newsletters',
    NEWS: 'tech-news',
    THOUGHT_LEADERSHIP: 'blog',
    WHITEPAPERS: 'whitepapers',
    VENDORS: 'vendor-directory',
    CONTACT: 'contact-us',
    INTERVIEWS_PODCASTS: 'interview-podcasts',
    INFOGRAPHICS: 'infographics',
    WEBINARS: 'webinar-videos',
    CASE_STUDIES: 'case-studies',
}